module.exports = __webpack_public_path__ + "static/media/AB_K2_13.5c79f18b.jpg";